import { render } from "./ParcelasPedidoEmAndamento.vue?vue&type=template&id=6e40f2bc&scoped=true"
import script from "./ParcelasPedidoEmAndamento.vue?vue&type=script&lang=js"
export * from "./ParcelasPedidoEmAndamento.vue?vue&type=script&lang=js"

import "./ParcelasPedidoEmAndamento.vue?vue&type=style&index=0&id=6e40f2bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e40f2bc"]])

export default __exports__